export const MENU = [{
    path: '/process',
    label: 'PROCESS'
}, {
    path: '/pricing',
    label: 'PRICING'
}, {
    path: '/about',
    label: 'ABOUT'
}, {
    path: '/visit',
    label: 'VISIT'
}];
